export const defaultPreferences = {
  kellyCriterion: 0.25,
  legsPerPage: 10,
  minBooksStraights: 3,
  minBooksSGP: 2,
  unitSize: 100,
  showAllMath: false,
  defaultBetMode: 'infer',
  autoSwitchMode: true,
  defaultSortMethod: 'ev',
  // Background query settings
  backgroundQueryMode: false, // When true, queries run in background by default
  // Sportsbook settings
  selectedSportsbooks: ['DraftKings', 'FanDuel', 'BetMGM'],
  sportsbookLimits: {
    'DraftKings': 1000,
    'FanDuel': 1000,
    'BetMGM': 1000,
    'Caesars': 1000,
    'PointsBet': 1000
  },
  enabledSportsbookLimits: true
};
